import { useState, type ReactNode } from 'react';
import { useMountEffect } from '@/shared/hooks/useMountEffect';
import { i18n } from '@/shared/i18n';
import { ChatStoreContext, createChatStore } from './chat.store';

/** Gives the chat inside it a store of its own, created once for the life of the scope. */
export function ChatStoreScope({ children }: { children: ReactNode }) {
  const [store] = useState(createChatStore);

  // The agent card is worded in the language it was fetched in.
  useMountEffect(() => {
    const reloadAgent = () => void store.getState().reloadCurrentAgent();
    i18n.on('languageChanged', reloadAgent);
    return () => i18n.off('languageChanged', reloadAgent);
  });

  return <ChatStoreContext.Provider value={store}>{children}</ChatStoreContext.Provider>;
}
